import normalVertex from './shader/v/normal.vert';
import logoFragment from './shader/f/logo.frag';


const vertex100 =
	/* glsl */ `
` + normalVertex;

const fragment100 =
	/* glsl */ `#extension GL_OES_standard_derivatives : enable
	precision highp float;
` + logoFragment;

const vertex300 =
	/* glsl */ `#version 300 es
	#define attribute in
	#define varying out
` + normalVertex;

const fragment300 =
	/* glsl */ `#version 300 es
	precision highp float;
	#define varying in
	#define texture2D texture
	#define gl_FragColor FragColor
	out vec4 FragColor;
` + logoFragment;


WEBGL.logo = {

	local : null,
	ready : false,

	font : {
		tex : null,
		gl : null,
		json : null,
	},

	para : {
		y : 1.2, // 1.05
	},

	targets : [],

	onInit( elem ){

		this.local = elem ? elem : document.querySelector('.c-local');

		const $logo = this.local.querySelectorAll('.js-gl-logo-t');
		const $bg   = this.local.querySelectorAll('.js-gl-logo-bg');
		const targets = [ ...$logo, ...$bg ];
		targets.forEach( (el,i) =>{
			this.targets.push({
				el : el,
				rect : { width:0, height:0, top:0, left:0 },
				type : el.dataset.type,
				observer : null,
				listerner : null,
				fontSize : 0,
				visible : false,
				key : el.dataset.key
			});
		});

		this.targets.forEach( (v) =>{
			v.listerner = (changes) => {
				changes.forEach((e) => {
					const isIntersecting = e.isIntersecting;
					if ( isIntersecting ) {
						v.visible = true;
					} else {
						v.visible = false;
					}
				});
			};
			v.observer = new IntersectionObserver( v.listerner, { threshold: 0 } );
			v.observer.observe( v.el );
		});

	},

	onDestroy(){

		//
		this.onScroll(0);

		//
		this.targets.forEach( (v,i) =>{
			const m = this.meshes[ v.key ];
			if( !m ) return false;
			m.mesh.visible = false;
		});

		//
		this.targets.forEach( (v,i) =>{
			if( v.observer ){
				v.observer.disconnect( v.el );
				v.observer = null;
			}
			if( v.listerner ) v.listerner = null;
		});
		this.targets = [];

	},

	meshes : {
		'T' : {
			str : 'T', 
			visible : 0,
			el : null,
			rect : { width:0, height:0, top:0, left:0 },
			gl : null,
			mesh : null,
			geometry : null,
			program : null,
			fontSize : 0
		},
		'H' : {
			str : 'H', 
			visible : 0,
			el : null,
			rect : { width:0, height:0, top:0, left:0 },
			gl : null,
			mesh : null,
			geometry : null,
			program : null,
			fontSize : 0
		},
		'E' : {
			str : 'E', 
			visible : 0,
			el : null,
			rect : { width:0, height:0, top:0, left:0 },
			gl : null,
			mesh : null,
			geometry : null,
			program : null,
			fontSize : 0
		},
		'O' : {
			str : 'O', 
			visible : 0,
			el : null,
			rect : { width:0, height:0, top:0, left:0 },
			gl : null,
			mesh : null,
			geometry : null,
			program : null,
			fontSize : 0
		},
		'N' : {
			str : 'N', 
			visible : 0,
			el : null,
			rect : { width:0, height:0, top:0, left:0 },
			gl : null,
			mesh : null,
			geometry : null,
			program : null,
			fontSize : 0
		},
		'EE' : {
			str : 'E', 
			visible : 0,
			el : null,
			rect : { width:0, height:0, top:0, left:0 },
			gl : null,
			mesh : null,
			geometry : null,
			program : null,
			fontSize : 0
		},
		'.' : {
			str : '.', 
			visible : 0,
			el : null,
			rect : { width:0, height:0, top:0, left:0 },
			gl : null,
			mesh : null,
			geometry : null,
			program : null,
			fontSize : 0
		},
	},

	anim : {
		mv : {
			leave : {
				tl : null,
				array : [
					{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },
				]
			},
			enter : {
				tl : null,
				array : [
					{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },
				]
			},
			array : [
				{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },
			]
		},
		scroll : {
			tl : null,
			array : [
				{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },
			]
		},
		// fs : {
		// 	tl : null,
		// 	array : [
		// 		{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },{ power : 1 },
		// 	]
		// }
	},

	once(){

		//
		this.scene = new OGL.Transform();
		this.target = new OGL.RenderTarget( WEBGL.gl, {
			width  : WEBGL.width  * WEBGL.res,
			height : WEBGL.height * WEBGL.res,
		});

		//
		this.font.tex = new OGL.Texture( WEBGL.gl, {
			generateMipmaps: true,
		});
		this.font.img = new Image();
		this.font.img.onload = () => ( this.font.tex.image = this.font.img );
		this.font.img.src = '/assets/fonts/logo/TheOnew400.png';

		//
		fetch('/assets/fonts/logo/TheOne_w400-msdf.json')
		.then(response => response.json())
		.then(data => {
			this.font.json = data;
			this.onLoaded();
		})
		.catch(error => {
			console.error('Error:', error);
		});

		//
		this.onInitBg();
		this.onInitAnim();

	},

	onLeaveAnim( prop = {s : pageTransition.anim.leave.s, e : pageTransition.anim.leave.e, d : pageTransition.anim.leave.d, g : pageTransition.stagger} ){
		if( this.anim.mv.leave.tl ) this.anim.mv.leave.tl.kill(); this.anim.mv.leave.tl = null;
		this.anim.mv.leave.tl = gsap.timeline();
		this.anim.mv.leave.tl.fromTo( this.anim.mv.array,{
				power    : 0,
			},
			{
				duration : prop.s - prop.g,
				ease     : prop.e,
				delay    : prop.d,
				stagger  : prop.g,
				power    : -1,
			}
		);
	},

	onEnterAnim( prop = {s : pageTransition.anim.enter.s, e : 'expo.out', d : pageTransition.anim.enter.d, g : pageTransition.stagger }){
		if( this.anim.mv.enter.tl ) this.anim.mv.enter.tl.kill(); this.anim.mv.enter.tl = null;
		this.anim.mv.enter.tl = gsap.timeline();
		this.anim.mv.enter.tl.fromTo( this.anim.mv.array,{
				power    : 1,
			},
			{
				duration : prop.s * 1.5,
				ease     : prop.e,
				delay    : prop.d * 0.5,
				stagger  : prop.g * 2,
				power    : 0,
			}
		);
	},

	onInitAnim(){

		//
		// this.anim.scroll.tl = gsap.timeline();
		// this.anim.scroll.tl.to( this.anim.scroll.array, {
		// 	power  : 0,
		// 	ease : 'power1.out',
		// 	stagger: 0.1
		// });
		// this.anim.scroll.tl.pause();

	},

	bg : {
		visible : 0,
		el : null,
		rect : { width:0, height:0, top:0, left:0 },
		gl : null,
		mesh : null,
		program : null,
		geometry : null
	},
	onInitBg(){
		this.bg.geometry = new OGL.Plane( WEBGL.gl,{ width : 1, height : 1 });
		this.bg.program = new OGL.Program( WEBGL.gl, {
			vertex: normalVertex,
			fragment : `
				precision highp float;
				uniform vec3 tColor;
				varying vec2 vUv;
				void main() {
					gl_FragColor = vec4( tColor, 1.0 );
				}
			`,
			transparent : false,
			cullFace : null,
			depthTest : false,
			depthWrite : false,
			uniforms : {
				tColor : { value : COLOR['black'].bg.ogl },
			},
		});
		this.bg.mesh = new OGL.Mesh( WEBGL.gl, { geometry : this.bg.geometry, program : this.bg.program });
		this.bg.mesh.setParent( this.scene );
		this.bg.mesh.visible = false;
	},

	onLoaded(){

		//
		Object.keys( this.meshes ).forEach( (key) => {

			const v = this.meshes[key];
			if( !v ) return false;

			v.gl = new OGL.Text({
				font  : this.font.json,
				text  : v.str,
				width : .5,
				align : 'left',
				letterSpacing: 0,
				size : 1,
				lineHeight: 1,
			});	

			v.program = new OGL.Program( WEBGL.gl, {
				vertex   : WEBGL.renderer.isWebgl2 ? vertex300 : vertex100,
				fragment : WEBGL.renderer.isWebgl2 ? fragment300 : fragment100,
				uniforms : {
					tColor : { value : COLOR['white'].bg.ogl },
					tMap : { value : this.font.tex },
				},
				transparent : true,
				cullFace : null,
				depthTest : false,
				depthWrite : false,
			});

			v.geometry = new OGL.Geometry( WEBGL.gl, {
				position: { size: 3, data: v.gl.buffers.position },
				uv: { size: 2, data: v.gl.buffers.uv },
				id: { size: 1, data: v.gl.buffers.id },
				index: { data: v.gl.buffers.index },
			});

			v.mesh = new OGL.Mesh( WEBGL.gl, { geometry : v.geometry, program : v.program });
			v.mesh.setParent( this.scene );
			v.mesh.visible = false;

		});

		this.onResize();
		this.onScroll(0);

		this.ready = true;

	},

	onRender(){

		//
		let indexScroll = 0;
		let indexMv = 0;
		let visibleBg = 0;
		let visibleLogo = 0;
		this.targets.forEach( (v,i) =>{

			//
			if( v.visible ){

				const rect = v.el.getBoundingClientRect();
				v.rect.top    = rect.top + pageScroll.scroll.y;
				v.rect.left   = rect.left;
				v.rect.width  = rect.width;
				v.rect.height = rect.height;

				if( v.type === 'bg' ){

					if( !this.bg.mesh ) return false;
					this.bg.mesh.scale.x = v.rect.width;
					this.bg.mesh.scale.y = v.rect.height;
					this.bg.mesh.position.y = WH/2 - this.bg.mesh.scale.y/2 - v.rect.top + pageScroll.scroll.y;
					visibleBg++;

				} else {

					const m = this.meshes[ v.key ];
					if( !m ) return false;
					m.mesh.position.x = -WW/2 + v.rect.left;

					//
					let ty = m.mesh.scale.x * 0.025;
					switch( v.type ){
						case 'scroll':
							const py1 = this.anim.scroll.array[ indexScroll ].power;
							// ty = m.mesh.scale.x * 0.03 + m.mesh.scale.x * py1 * 2;
							ty = m.mesh.scale.x * 0.03;
							m.mesh.position.y =  WH/2 - v.rect.top + pageScroll.scroll.y - ty;
							indexScroll++;
						break;
						case 'mv':
							const py2 = this.anim.mv.array[ indexMv ] ? this.anim.mv.array[ indexMv ].power : 0;
							m.mesh.position.y =  WH/2 - v.rect.top - ty + pageScroll.scroll.y * this.para.y - py2 * v.fontSize;
							indexMv++;
						break;
						case 'fs':
							m.mesh.position.y = WH/2 - v.rect.top - ty + pageScroll.scroll.y;
						break;
					}

					//
					m.mesh.scale.x = v.fontSize;
					m.mesh.scale.y = v.fontSize;

					//
					visibleLogo++;

				}

			}

		});


		// VISIBLE
		this.bg.mesh.visible = visibleBg != 0 ? true : false;
		this.targets.forEach( (v,i) =>{
			if( !this.meshes[ v.key ] ) return false;
			this.meshes[ v.key ].mesh.visible = visibleLogo != 0 ? true : false;
		});

	},

	onResize(){

		this.targets.forEach( (v,i) =>{
			const rect = v.el.getBoundingClientRect();
			v.rect.top = rect.top + pageScroll.scroll.y;
			v.rect.left = rect.left;
			v.rect.width = rect.width;
			v.rect.height = rect.height;
			v.fontSize = this.getScale( v.el ) * 0.975;
		});

	},

	onScroll(){
		this.targets.forEach( (v,i) =>{
			if( !v.visible ) return false;
			if( v.type === 'mv' ){
				const uy = this.meshes[ v.key ].mesh.scale.x * 0.025;
				this.meshes[ v.key ].mesh.position.y =  WH/2 - v.rect.top - uy + pageScroll.scroll.y * this.para.y;
			}
		});
	},

	getScale( el ){
		const computedStyle = window.getComputedStyle(el);
		const fontSize = parseFloat( computedStyle.getPropertyValue("font-size") );
		return fontSize;
	}

}





















